// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19IRU","colMin":"styles_colMin__2cEGL"};